import { createSlice, PayloadAction } from '@reduxjs/toolkit';
interface Order {
  orderID: string;
  customerName: string;
  orderType: string;
}
export interface OrderDetailsSliceObject {
  order: Order;
}
const initialOrder: Order = {
  orderID: '',
  customerName: '',
  orderType: '',
};
const orderDetailsSlice = createSlice({
  name: 'orderdetails',
  initialState: { order: initialOrder },
  reducers: {
    setOrderDetails: (state, action: PayloadAction<Order>) => {
      return { order: action.payload };
    },
    clearOrderDetails: state => {
      return { order: initialOrder };
    },
  },
});

export const { setOrderDetails, clearOrderDetails } = orderDetailsSlice.actions;
export default orderDetailsSlice.reducer;
